module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isEarlyAdopter) ? _c('div', {
    staticClass: "ql-bugreporter"
  }, [(!_vm.open) ? _c('button', {
    staticClass: "ql-bugreporter-fab",
    attrs: {
      "title": "Report a bug (early adopters)",
      "aria-label": "Report a bug"
    },
    on: {
      "click": _vm.openDialog
    }
  }, [_c('span', {
    staticClass: "ql-bugreporter-fab-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("🐞")])]) : _vm._e(), _vm._v(" "), (_vm.open) ? _c('div', {
    staticClass: "ql-bugreporter-overlay",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.closeDialog.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "ql-bugreporter-panel",
    attrs: {
      "role": "dialog",
      "aria-label": "Report a bug"
    },
    on: {
      "keydown": function($event) {
        $event.stopPropagation();
      },
      "keyup": function($event) {
        $event.stopPropagation();
      },
      "keypress": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('button', {
    staticClass: "ql-bugreporter-close",
    attrs: {
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("×")]), _vm._v(" "), (_vm.state !== 'success') ? [_c('h3', {
    staticClass: "ql-bugreporter-title"
  }, [_vm._v("Report a Bug")]), _vm._v(" "), _c('p', {
    staticClass: "ql-bugreporter-sub"
  }, [_vm._v("Describe the issue you encountered. A few technical details are captured automatically to help us debug.")]), _vm._v(" "), _c('label', {
    staticClass: "ql-bugreporter-label",
    attrs: {
      "for": "ql-bug-title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    staticClass: "ql-bugreporter-input",
    attrs: {
      "id": "ql-bug-title",
      "disabled": _vm.submitting,
      "type": "text",
      "maxlength": "200",
      "placeholder": "Brief summary of the issue"
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "ql-bugreporter-label",
    attrs: {
      "for": "ql-bug-desc"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }],
    staticClass: "ql-bugreporter-textarea",
    attrs: {
      "id": "ql-bug-desc",
      "disabled": _vm.submitting,
      "rows": "4",
      "placeholder": "What happened? What did you expect?"
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.description = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "ql-bugreporter-label",
    attrs: {
      "for": "ql-bug-sev"
    }
  }, [_vm._v("Severity")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.severity),
      expression: "severity"
    }],
    staticClass: "ql-bugreporter-select",
    attrs: {
      "id": "ql-bug-sev",
      "disabled": _vm.submitting
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.severity = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.severities), function(opt) {
    return _c('option', {
      key: opt,
      domProps: {
        "value": opt
      }
    }, [_vm._v(_vm._s(opt))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "ql-bugreporter-context"
  }, [_c('div', [_c('strong', [_vm._v("Route:")]), _vm._v(" " + _vm._s(_vm.context.route))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Module:")]), _vm._v(" " + _vm._s(_vm.context.module))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Browser:")]), _vm._v(" " + _vm._s(_vm.context.browser))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("OS:")]), _vm._v(" " + _vm._s(_vm.context.os))])]), _vm._v(" "), (_vm.state === 'error') ? _c('p', {
    staticClass: "ql-bugreporter-error"
  }, [_vm._v("\n                    Couldn't send that. "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit.apply(null, arguments)
      }
    }
  }, [_vm._v("Retry")]), _vm._v(", or email\n                    "), _c('a', {
    attrs: {
      "href": _vm.mailto
    }
  }, [_vm._v("support@thecuelist.com")]), _vm._v(".\n                ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ql-bugreporter-actions"
  }, [_c('button', {
    staticClass: "ql-bugreporter-btn ghost",
    attrs: {
      "disabled": _vm.submitting
    },
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "ql-bugreporter-btn primary",
    attrs: {
      "disabled": _vm.submitting || !_vm.title.trim()
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.submitting ? 'Sending…' : 'Submit Report') + "\n                    ")])])] : [_c('h3', {
    staticClass: "ql-bugreporter-title"
  }, [_vm._v(_vm._s(_vm.sentOnline ? 'Thanks — report sent' : 'Thanks — report queued'))]), _vm._v(" "), _c('p', {
    staticClass: "ql-bugreporter-success"
  }, [_vm._v("\n                    " + _vm._s(_vm.sentOnline ?
    'Our team has been notified.' :
    "You're offline — it will send automatically when you reconnect.") + "\n                ")]), _vm._v(" "), _c('p', {
    staticClass: "ql-bugreporter-ref"
  }, [_vm._v("Reference: "), _c('code', [_vm._v(_vm._s(_vm.reportId))])]), _vm._v(" "), _c('div', {
    staticClass: "ql-bugreporter-actions"
  }, [_c('button', {
    staticClass: "ql-bugreporter-btn primary",
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("Done")])])]], 2)]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b353f88","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BugReporter.vue
// module id = 1220
// module chunks = 21